import { render, staticRenderFns } from "./certificatesView.vue?vue&type=template&id=6999c6ec&scoped=true"
import script from "./certificatesView.vue?vue&type=script&lang=js"
export * from "./certificatesView.vue?vue&type=script&lang=js"
import style0 from "./certificatesView.vue?vue&type=style&index=0&id=6999c6ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6999c6ec",
  null
  
)

export default component.exports